import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';

import { ButtonComponent } from '../../common/button/components/button/button.component';
import { MessageComponent } from '../../common/message/message.component';

@Component({
  selector: 'rt-bulk-selection-messages',
  templateUrl: './bulk-selection-messages.component.html',
  styleUrls: ['./bulk-selection-messages.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MessageComponent, ButtonComponent, TranslatePipe],
})
export class BulkSelectionMessagesComponent {
  @Input() public currentViewSelectedCount: number;
  @Input() public selectedCount: number;
  @Input() public hasBottomMargin: boolean = true;
  @Input() public hasTopMarginMedium: boolean = true;

  public clearSelection = output<void>();
}
